import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, heroImage, trackCheckout } from '../data/offer';
const highlights = ['Professional Coaching System', '5 Bonus Guides Included', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-base" data-id="element-143" data-mp="4n9zsnvorq5t">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-144" data-mp="128frrovbsnyc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-145" data-mp="xa4hjd14cbfl">
          <div className="inline-block px-3 py-1 rounded-full border border-accent/30 bg-accent-soft text-accent-dark font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-146" data-mp="nb6kflpmn9kz">
            BOXING COACH READY
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight mb-4 sm:mb-6 text-ink" data-id="element-147" data-mp="384s62qvt8p44">
            Solve an Entire Year of Boxing Sessions in Just{' '}
            <span className="text-accent" data-id="element-148" data-mp="3o59bpicfn4e0">5 Minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-149" data-mp="39cfotbutzlzb">
          <img src={heroImage} alt="Boxing Coach Ready — 7 complete volumes, 150 ready-to-coach sessions, Session Finder and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-150" data-mp="35aubxqiar7p4" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-151" data-mp="2hk886bfbs9kx">
          <p className="text-sm sm:text-lg md:text-xl font-semibold text-ink leading-snug max-w-2xl mx-auto mb-3" data-id="element-152" data-mp="s3ck463mvbog">
            150 Ready-to-Coach Boxing Sessions · Session Finder · 7 Complete Volumes · 5 Bonus
            Guides
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-153" data-mp="ddf4iejrruav">
            The complete professional coaching system for boxing coaches who want to spend less time
            planning and walk into every session knowing exactly what to teach, how to coach it, how
            to correct it, and what should come next.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-154" data-mp="x14ohzlgsq9j">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-155" data-mp="x0l3ga0iplra">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-graphite-light" data-id="element-156" data-mp="1xavzepf1qi9w">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-157" data-mp="269hgeg4vdp8k">
                <CheckCircle size={14} className="text-accent" data-id="element-158" data-mp="2b0pon8ugr4k5" />
                <span data-id="element-159" data-mp="2b20qh34cm28m">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}